(function () {
  if (window.ddpThemeInitialized) return;
  window.ddpThemeInitialized = true;

  function formatMoney(cents) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

    try {
      return (Number(cents) / 100).toLocaleString('fr-FR', {
        style: 'currency',
        currency: currency
      });
    } catch (error) {
      return (Number(cents) / 100).toFixed(2) + ' ' + currency;
    }
  }

  function setMobileGrid(button) {
    var grid = document.querySelector('[data-ddp-product-grid]');
    var view = button.getAttribute('data-ddp-grid-view');

    if (!grid || !view) return;

    grid.classList.toggle('mobile-grid-one', view === '1');
    grid.classList.toggle('mobile-grid-two', view !== '1');

    document.querySelectorAll('[data-ddp-grid-view]').forEach(function (item) {
      item.classList.toggle('is-active', item === button);
    });
  }

  function getProductVariants(section) {
    var json = section && section.querySelector('[data-ddp-product-variants]');
    if (!json) return [];

    try {
      return JSON.parse(json.textContent);
    } catch (error) {
      return [];
    }
  }

  function getVariantOptions(variant) {
    if (!variant) return [];
    if (Array.isArray(variant.options)) return variant.options;

    return [variant.option1, variant.option2, variant.option3].filter(function (value) {
      return value !== null && typeof value !== 'undefined';
    });
  }

  function getVariantMediaId(variant) {
    if (!variant) return null;
    if (variant.featured_media_id) return variant.featured_media_id;
    if (variant.featured_media && variant.featured_media.id) return variant.featured_media.id;
    if (variant.featured_image_id) return variant.featured_image_id;
    if (variant.featured_image && variant.featured_image.id) return variant.featured_image.id;
    if (variant.image && variant.image.id) return variant.image.id;
    return null;
  }

  function findProductMediaNode(section, mediaId, selector) {
    var target = null;
    if (!section || !mediaId) return target;

    section.querySelectorAll(selector).forEach(function (node) {
      if (!target && String(node.getAttribute('data-media-id')) === String(mediaId)) {
        target = node;
      }
    });

    return target;
  }

  function isMobileProductGalleryList(list) {
    return Boolean(
      list &&
      window.matchMedia &&
      window.matchMedia('(max-width: 989px)').matches &&
      window.getComputedStyle(list).display === 'flex'
    );
  }

  function syncProductGalleryState(section, mediaNode) {
    if (!section || !mediaNode) return;

    var mediaId = mediaNode.getAttribute('data-media-id');
    var mediaNodes = Array.prototype.slice.call(section.querySelectorAll('[data-ddp-product-media]'));
    var currentIndex = mediaNodes.indexOf(mediaNode);
    var currentNode = section.querySelector('[data-ddp-gallery-current]');
    var totalNode = section.querySelector('[data-ddp-gallery-total]');

    mediaNodes.forEach(function (node) {
      node.classList.toggle('is-active', node === mediaNode);
    });

    section.querySelectorAll('[data-ddp-product-thumb]').forEach(function (thumb) {
      var isActive = String(thumb.getAttribute('data-media-id')) === String(mediaId);
      thumb.classList.toggle('is-active', isActive);
      if (isActive) {
        thumb.setAttribute('aria-current', 'true');
      } else {
        thumb.removeAttribute('aria-current');
      }
    });

    if (currentNode && currentIndex > -1) {
      currentNode.textContent = String(currentIndex + 1);
    }
    if (totalNode && mediaNodes.length) {
      totalNode.textContent = String(mediaNodes.length);
    }
  }

  function getNearestProductMedia(section) {
    var list = section && section.querySelector('.ddp-product-gallery__list');
    if (!isMobileProductGalleryList(list)) return null;

    var mediaNodes = Array.prototype.slice.call(section.querySelectorAll('[data-ddp-product-media]'));
    var target = null;
    var smallestDistance = Infinity;

    mediaNodes.forEach(function (node) {
      var distance = Math.abs((node.offsetLeft - list.offsetLeft) - list.scrollLeft);
      if (distance < smallestDistance) {
        smallestDistance = distance;
        target = node;
      }
    });

    return target;
  }

  function scrollProductGalleryToMedia(section, mediaNode) {
    var list = section && section.querySelector('.ddp-product-gallery__list');
    if (!mediaNode) return;

    if (isMobileProductGalleryList(list) && list.contains(mediaNode)) {
      list.scrollTo({
        left: mediaNode.offsetLeft - list.offsetLeft,
        behavior: 'smooth'
      });
      return;
    }

    try {
      mediaNode.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest'
      });
    } catch (error) {
      mediaNode.scrollIntoView();
    }
  }

  function updateProductMedia(section, variant) {
    var mediaId = getVariantMediaId(variant);
    var target = findProductMediaNode(section, mediaId, '[data-ddp-product-media]');
    if (!target) return;

    syncProductGalleryState(section, target);
    scrollProductGalleryToMedia(section, target);
  }

  function isVariantAvailable(variant) {
    if (!variant) return false;
    if (typeof variant.available !== 'undefined') return Boolean(variant.available);
    if (typeof variant.availableForSale !== 'undefined') return Boolean(variant.availableForSale);
    return true;
  }

  function findVariantById(variants, id) {
    return variants.find(function (variant) {
      return String(variant.id) === String(id);
    });
  }

  function getSelectedOptions(section) {
    var selectedOptions = [];

    section.querySelectorAll('[data-ddp-option-button].is-selected').forEach(function (button) {
      var position = Number(button.getAttribute('data-option-position'));
      if (!position) return;
      selectedOptions[position - 1] = button.getAttribute('data-option-value');
    });

    return selectedOptions;
  }

  function findVariantForOptions(variants, selectedOptions) {
    if (!selectedOptions.length || selectedOptions.some(function (value) {
      return typeof value === 'undefined';
    })) {
      return null;
    }

    return variants.find(function (variant) {
      var options = getVariantOptions(variant);

      return selectedOptions.every(function (value, index) {
        return String(options[index]) === String(value);
      });
    }) || null;
  }

  function syncButtonsFromVariant(section, variant) {
    var variantOptions = getVariantOptions(variant);
    if (!variantOptions.length) return;

    section.querySelectorAll('[data-ddp-option-button]').forEach(function (button) {
      var position = Number(button.getAttribute('data-option-position'));
      var isSelected = String(variantOptions[position - 1]) === String(button.getAttribute('data-option-value'));

      button.classList.toggle('is-selected', isSelected);
      button.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });
  }

  function updateOptionAvailability(section, variants, selectedOptions) {
    section.querySelectorAll('[data-ddp-option-button]').forEach(function (button) {
      var position = Number(button.getAttribute('data-option-position'));
      var value = button.getAttribute('data-option-value');
      var candidateOptions = selectedOptions.slice();
      candidateOptions[position - 1] = value;

      var hasAnyAvailableVariant = variants.some(function (variant) {
        return String(getVariantOptions(variant)[position - 1]) === String(value) && isVariantAvailable(variant);
      });

      var hasExactAvailableVariant = variants.some(function (variant) {
        var variantOptions = getVariantOptions(variant);
        var exactMatch = candidateOptions.every(function (selectedValue, index) {
          return typeof selectedValue === 'undefined' || String(variantOptions[index]) === String(selectedValue);
        });

        return exactMatch && isVariantAvailable(variant);
      });

      button.disabled = !hasAnyAvailableVariant;
      button.classList.toggle('is-disabled', !hasAnyAvailableVariant);
      button.classList.toggle('is-limited', hasAnyAvailableVariant && !hasExactAvailableVariant);
      button.setAttribute('aria-disabled', hasAnyAvailableVariant ? 'false' : 'true');
    });
  }

  function syncCompactOptionLabels(section) {
    if (!section) return;

    section.querySelectorAll('[data-ddp-compact-option-value]').forEach(function (valueNode) {
      var position = valueNode.getAttribute('data-option-position');
      var selectedButton = section.querySelector('[data-ddp-option-button][data-option-position="' + position + '"].is-selected');
      if (selectedButton) {
        valueNode.textContent = selectedButton.getAttribute('data-option-value') || selectedButton.textContent.trim();
      }
    });
  }

  function closeCompactOptionPanels(section, restoreFocus) {
    if (!section) return;

    var focusedTrigger = null;
    section.querySelectorAll('[data-ddp-compact-option-trigger][aria-expanded="true"]').forEach(function (trigger) {
      if (!focusedTrigger) focusedTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'false');
    });

    section.querySelectorAll('[data-ddp-compact-option-panel]').forEach(function (panel) {
      panel.classList.remove('is-compact-open');
      panel.setAttribute('aria-hidden', 'true');
    });

    if (restoreFocus && focusedTrigger) {
      focusedTrigger.focus();
    }
  }

  function openCompactOptionPanel(trigger) {
    var section = trigger && trigger.closest('[data-ddp-product-section]');
    if (!section) return;

    var position = trigger.getAttribute('data-option-position');
    var panel = section.querySelector('[data-ddp-compact-option-panel][data-option-position="' + position + '"]');
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';

    closeCompactOptionPanels(section, false);
    if (!panel || isOpen) return;

    trigger.setAttribute('aria-expanded', 'true');
    panel.classList.add('is-compact-open');
    panel.setAttribute('aria-hidden', 'false');

    var selectedButton = panel.querySelector('[data-ddp-option-button].is-selected');
    var firstButton = selectedButton || panel.querySelector('[data-ddp-option-button]:not(:disabled)');
    if (firstButton) {
      firstButton.focus({ preventScroll: true });
    }
  }

  function applyProductVariant(section, variant, options) {
    var shouldUpdateMedia = !options || options.updateMedia !== false;
    var hiddenInput = section.querySelector('[data-ddp-variant-id-input]');
    var addButton = section.querySelector('[data-ddp-add-cart]');
    var addLabel = section.querySelector('[data-ddp-add-cart-label]');
    var status = section.querySelector('[data-ddp-variant-status]');
    var available = isVariantAvailable(variant);

    if (hiddenInput) {
      hiddenInput.value = variant ? variant.id : '';
    }

    if (variant && typeof variant.price !== 'undefined') {
      section.querySelectorAll('[data-ddp-product-price]').forEach(function (priceNode) {
        priceNode.textContent = formatMoney(variant.price);
      });
    }

    if (addButton) {
      addButton.disabled = !available;
    }
    if (addLabel) {
      addLabel.textContent = available ? 'ajouter au panier' : 'indisponible';
    }
    if (status) {
      if (!variant) {
        status.hidden = false;
        status.textContent = 'Cette combinaison n’existe pas.';
      } else if (!available) {
        status.hidden = false;
        status.textContent = 'Cette combinaison est indisponible.';
      } else {
        status.hidden = true;
        status.textContent = '';
      }
    }

    if (shouldUpdateMedia && variant) {
      updateProductMedia(section, variant);
    }

    syncCompactOptionLabels(section);
  }

  function updateProductOption(button) {
    var section = button.closest('[data-ddp-product-section]');
    if (!section || button.disabled) return;

    var variants = getProductVariants(section);
    if (!variants.length) return;

    var position = button.getAttribute('data-option-position');
    section.querySelectorAll('[data-ddp-option-button][data-option-position="' + position + '"]').forEach(function (item) {
      var isSelected = item === button;
      item.classList.toggle('is-selected', isSelected);
      item.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
    });

    var selectedOptions = getSelectedOptions(section);
    var variant = findVariantForOptions(variants, selectedOptions);
    applyProductVariant(section, variant);
    updateOptionAvailability(section, variants, selectedOptions);
    syncCompactOptionLabels(section);
  }

  function initProductOptions() {
    document.querySelectorAll('[data-ddp-product-section]').forEach(function (section) {
      var variants = getProductVariants(section);
      var optionsWrapper = section.querySelector('[data-ddp-product-options]');
      if (!variants.length || !optionsWrapper) return;

      var hiddenInput = section.querySelector('[data-ddp-variant-id-input]');
      var selectedVariant = hiddenInput && hiddenInput.value ? findVariantById(variants, hiddenInput.value) : null;
      if (selectedVariant) {
        syncButtonsFromVariant(section, selectedVariant);
      }

      var selectedOptions = getSelectedOptions(section);
      var variant = findVariantForOptions(variants, selectedOptions) || selectedVariant;
      if (variant) {
        syncButtonsFromVariant(section, variant);
      }

      selectedOptions = getSelectedOptions(section);
      applyProductVariant(section, findVariantForOptions(variants, selectedOptions), { updateMedia: false });
      updateOptionAvailability(section, variants, selectedOptions);
      syncCompactOptionLabels(section);
    });
  }

  function initProductGalleries() {
    document.querySelectorAll('[data-ddp-product-section]').forEach(function (section) {
      var list = section.querySelector('.ddp-product-gallery__list');
      var activeMedia = section.querySelector('[data-ddp-product-media].is-active') || section.querySelector('[data-ddp-product-media]');

      if (activeMedia) {
        syncProductGalleryState(section, activeMedia);
      }

      if (!list || list.dataset.ddpGallerySyncInitialized === 'true') return;
      list.dataset.ddpGallerySyncInitialized = 'true';

      var ticking = false;
      list.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;

        window.requestAnimationFrame(function () {
          var nearest = getNearestProductMedia(section);
          if (nearest) {
            syncProductGalleryState(section, nearest);
          }
          ticking = false;
        });
      }, { passive: true });
    });
  }

  function updateProductVariant(input) {
    var section = input.closest('[data-ddp-product-section]');
    if (!section) return;

    var variants = getProductVariants(section);
    var variant = findVariantById(variants, input.value);
    if (!variant) return;

    section.querySelectorAll('.ddp-variant-pill').forEach(function (pill) {
      pill.classList.toggle('is-active', pill.contains(input));
    });

    applyProductVariant(section, variant);
  }

  function changeQuantity(button, direction) {
    var wrapper = button.closest('.ddp-qty');
    var input = wrapper && wrapper.querySelector('[data-ddp-qty-input]');
    if (!input) return;

    var current = parseInt(input.value || '1', 10);
    var next = Math.max(1, current + direction);
    input.value = next;
  }

  function setProductCartStatus(section, message, isError) {
    var status = section && section.querySelector('[data-ddp-variant-status]');
    if (!status) return;

    status.hidden = !message;
    status.textContent = message || '';
    status.classList.toggle('is-error', Boolean(isError));
  }

  function syncCartCount(itemCount) {
    document.querySelectorAll('a[href]').forEach(function (link) {
      var url;
      try {
        url = new URL(link.href, window.location.origin);
      } catch (error) {
        return;
      }

      if (url.pathname !== '/cart') return;

      var countNode = link.querySelector('span');
      if (countNode) {
        countNode.textContent = '(' + itemCount + ')';
      }
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (cart) {
        if (typeof cart.item_count !== 'undefined') {
          syncCartCount(cart.item_count);
        }
      });
  }

  function submitProductForm(event, form) {
    if (!window.fetch || !window.FormData) return;

    var section = form.closest('[data-ddp-product-section]');
    var addButton = form.querySelector('[data-ddp-add-cart]');
    var addLabel = form.querySelector('[data-ddp-add-cart-label]');
    var defaultLabel = addLabel ? addLabel.textContent : '';

    if (!section || !addButton) return;

    event.preventDefault();

    if (addButton.disabled) return;

    if (form.dataset.ddpCartSubmitting === 'true') return;
    form.dataset.ddpCartSubmitting = 'true';

    addButton.disabled = true;
    if (addLabel) {
      addLabel.textContent = 'ajout...';
    }
    setProductCartStatus(section, '', false);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: new FormData(form)
    })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            var error = new Error(payload.description || payload.message || 'Impossible d’ajouter cette pièce.');
            error.payload = payload;
            throw error;
          }

          return payload;
        });
      })
      .then(function () {
        return refreshCartCount();
      })
      .then(function () {
        if (addLabel) {
          addLabel.textContent = 'ajouté';
        }
        window.setTimeout(function () {
          addButton.disabled = false;
          if (addLabel) {
            addLabel.textContent = defaultLabel || 'ajouter au panier';
          }
        }, 1400);
      })
      .catch(function (error) {
        setProductCartStatus(section, error.message || 'Impossible d’ajouter cette pièce.', true);
        if (addLabel) {
          addLabel.textContent = 'erreur';
        }
        window.setTimeout(function () {
          addButton.disabled = false;
          if (addLabel) {
            addLabel.textContent = defaultLabel || 'ajouter au panier';
          }
        }, 1800);
      })
      .finally(function () {
        form.dataset.ddpCartSubmitting = 'false';
      });
  }

  function syncFilterState() {
    var hasOpenFilter = false;

    document.querySelectorAll('[data-ddp-filter-menu]').forEach(function (menu) {
      var summary = menu.querySelector('[data-ddp-filter-summary]');
      var isOpen = menu.hasAttribute('open');

      if (isOpen) {
        hasOpenFilter = true;
      }

      if (summary) {
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    });

    document.body.classList.toggle('ddp-filter-is-open', hasOpenFilter);
    syncGlobalSheetState();
  }

  function resetFilterMenuScroll(menu) {
    if (!menu) return;

    var panel = menu.querySelector('.ddp-filter-menu__panel');
    var collectionPanel = menu.closest('[data-ddp-collection-filter-panel]');
    var mobileScroller = collectionPanel && collectionPanel.querySelector('.ddp-filter-panel__mobile-scroll');

    if (mobileScroller) {
      mobileScroller.scrollTop = 0;
    }

    if (panel) {
      panel.scrollTop = 0;
    }
  }

  function closeFilterMenu(menu, restoreFocus) {
    if (!menu) return;

    var summary = menu.querySelector('[data-ddp-filter-summary]');
    menu.removeAttribute('open');
    syncFilterState();

    if (restoreFocus && summary) {
      summary.focus();
    }
  }

  function closeAllFilterMenus(restoreFocus) {
    var focusedSummary = null;

    document.querySelectorAll('[data-ddp-filter-menu][open]').forEach(function (menu) {
      if (!focusedSummary) {
        focusedSummary = menu.querySelector('[data-ddp-filter-summary]');
      }
      menu.removeAttribute('open');
    });

    syncFilterState();

    if (restoreFocus && focusedSummary) {
      focusedSummary.focus();
    }
  }

  var collectionFilterTrigger = null;

  function getCollectionFilterPanel() {
    return document.querySelector('[data-ddp-collection-filter-panel]');
  }

  function syncCollectionFilterTriggers(isOpen) {
    document.querySelectorAll('[data-ddp-collection-filter-open]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function openCollectionFilterPanel(trigger) {
    var panel = getCollectionFilterPanel();
    if (!panel) return;

    collectionFilterTrigger = trigger || collectionFilterTrigger;
    document.body.classList.add('ddp-collection-filter-is-open');
    panel.setAttribute('aria-hidden', 'false');
    syncCollectionFilterTriggers(true);
    syncGlobalSheetState();

    var closeButton = panel.querySelector('[data-ddp-collection-filter-close]');
    if (closeButton) {
      window.setTimeout(function () {
        closeButton.focus();
      }, 0);
    }
  }

  function closeCollectionFilterPanel(restoreFocus) {
    var panel = getCollectionFilterPanel();
    if (!panel) return;

    document.body.classList.remove('ddp-collection-filter-is-open');
    if (window.matchMedia && window.matchMedia('(max-width: 989px)').matches) {
      panel.setAttribute('aria-hidden', 'true');
    } else {
      panel.removeAttribute('aria-hidden');
    }
    syncCollectionFilterTriggers(false);
    closeAllFilterMenus(false);
    syncGlobalSheetState();

    if (restoreFocus && collectionFilterTrigger) {
      collectionFilterTrigger.focus();
    }
  }

  function syncNavMenuState() {
    var hasOpenNav = false;

    document.querySelectorAll('[data-ddp-nav-menu]').forEach(function (menu) {
      var summary = menu.querySelector('[data-ddp-nav-summary]');
      var isOpen = menu.hasAttribute('open');

      if (isOpen) {
        hasOpenNav = true;
      }

      if (summary) {
        summary.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      }
    });

    document.body.classList.toggle('ddp-nav-is-open', hasOpenNav);
    document.querySelectorAll('[data-ddp-mobile-shop-trigger]').forEach(function (trigger) {
      var shopMenu = document.querySelector('.ddp-mobile-dock .ddp-shop-menu[data-ddp-nav-menu]');
      trigger.setAttribute('aria-expanded', shopMenu && shopMenu.hasAttribute('open') ? 'true' : 'false');
    });
    syncGlobalSheetState();
  }

  function syncGlobalSheetState() {
    var hasOpenSheet = Boolean(
      document.querySelector('[data-ddp-nav-menu][open]') ||
      document.querySelector('[data-ddp-filter-menu][open]') ||
      document.body.classList.contains('ddp-collection-filter-is-open')
    );

    document.body.classList.toggle('ddp-sheet-is-open', hasOpenSheet);
  }

  function closeAllNavMenus(restoreFocus) {
    var focusedSummary = null;

    document.querySelectorAll('[data-ddp-nav-menu][open]').forEach(function (menu) {
      if (!focusedSummary) {
        focusedSummary = menu.querySelector('[data-ddp-nav-summary]');
      }
      menu.removeAttribute('open');
    });

    syncNavMenuState();

    if (restoreFocus && focusedSummary) {
      focusedSummary.focus();
    }
  }

  function closeNavMenu(menu, restoreFocus) {
    if (!menu) {
      closeAllNavMenus(restoreFocus);
      return;
    }

    var summary = menu.querySelector('[data-ddp-nav-summary]');
    menu.removeAttribute('open');
    syncNavMenuState();

    if (restoreFocus && summary) {
      summary.focus();
    }
  }

  function openMobileDockShopMenu(trigger) {
    var shopMenu = document.querySelector('.ddp-mobile-dock .ddp-shop-menu[data-ddp-nav-menu]');
    if (!shopMenu) return;

    document.querySelectorAll('[data-ddp-nav-menu][open]').forEach(function (menu) {
      if (menu !== shopMenu) {
        menu.removeAttribute('open');
      }
    });

    shopMenu.setAttribute('open', '');
    syncNavMenuState();

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  document.addEventListener('click', function (event) {
    var navBackdrop = event.target.closest('[data-ddp-nav-backdrop]');
    if (navBackdrop) {
      event.preventDefault();
      closeAllNavMenus(true);
      return;
    }

    var navCloseButton = event.target.closest('[data-ddp-nav-close]');
    if (navCloseButton) {
      event.preventDefault();
      closeNavMenu(navCloseButton.closest('[data-ddp-nav-menu]'), true);
      return;
    }

    var collectionFilterOpenButton = event.target.closest('[data-ddp-collection-filter-open]');
    if (collectionFilterOpenButton) {
      event.preventDefault();
      openCollectionFilterPanel(collectionFilterOpenButton);
      return;
    }

    var mobileBackTrigger = event.target.closest('[data-ddp-mobile-back-trigger]');
    if (mobileBackTrigger) {
      if (document.referrer && window.history.length > 1) {
        try {
          var referrerUrl = new URL(document.referrer);
          if (referrerUrl.origin === window.location.origin) {
            event.preventDefault();
            window.history.back();
          }
        } catch (error) {
          return;
        }
      }
      return;
    }

    var mobileShopTrigger = event.target.closest('[data-ddp-mobile-shop-trigger]');
    if (mobileShopTrigger) {
      event.preventDefault();
      openMobileDockShopMenu(mobileShopTrigger);
      return;
    }

    var collectionFilterCloseButton = event.target.closest('[data-ddp-collection-filter-close]');
    if (collectionFilterCloseButton) {
      event.preventDefault();
      closeCollectionFilterPanel(true);
      return;
    }

    if (event.target.closest('[data-ddp-filter-backdrop]')) {
      event.preventDefault();
      closeCollectionFilterPanel(true);
      closeAllFilterMenus(true);
      return;
    }

    var closeButton = event.target.closest('[data-ddp-filter-close]');
    if (closeButton) {
      event.preventDefault();
      closeFilterMenu(closeButton.closest('[data-ddp-filter-menu]'), true);
      return;
    }

    if (!event.target.closest('.ddp-filter-menu')) {
      closeAllFilterMenus(false);
    }

    if (!event.target.closest('[data-ddp-nav-menu]')) {
      closeAllNavMenus(false);
    }

    if (!event.target.closest('[data-ddp-product-buybar]')) {
      document.querySelectorAll('[data-ddp-product-section]').forEach(function (section) {
        closeCompactOptionPanels(section, false);
      });
    }

    var productThumb = event.target.closest('[data-ddp-product-thumb]');
    if (productThumb) {
      var thumbSection = productThumb.closest('[data-ddp-product-section]');
      var thumbList = thumbSection && thumbSection.querySelector('.ddp-product-gallery__list');
      var thumbMediaId = productThumb.getAttribute('data-media-id');
      var thumbTarget = findProductMediaNode(thumbSection, thumbMediaId, '[data-ddp-product-media]');

      if (thumbTarget && isMobileProductGalleryList(thumbList)) {
        event.preventDefault();
        syncProductGalleryState(thumbSection, thumbTarget);
        scrollProductGalleryToMedia(thumbSection, thumbTarget);
        return;
      }
    }

    var compactTrigger = event.target.closest('[data-ddp-compact-option-trigger]');
    if (compactTrigger) {
      event.preventDefault();
      openCompactOptionPanel(compactTrigger);
      return;
    }

    var compactClose = event.target.closest('[data-ddp-compact-option-close]');
    if (compactClose) {
      event.preventDefault();
      closeCompactOptionPanels(compactClose.closest('[data-ddp-product-section]'), true);
      return;
    }

    var optionButton = event.target.closest('[data-ddp-option-button]');
    if (optionButton) {
      event.preventDefault();
      updateProductOption(optionButton);
      closeCompactOptionPanels(optionButton.closest('[data-ddp-product-section]'), false);
      return;
    }

    var gridButton = event.target.closest('[data-ddp-grid-view]');
    if (gridButton) {
      event.preventDefault();
      setMobileGrid(gridButton);
      return;
    }

    var minusButton = event.target.closest('[data-ddp-qty-minus]');
    if (minusButton) {
      event.preventDefault();
      changeQuantity(minusButton, -1);
      return;
    }

    var plusButton = event.target.closest('[data-ddp-qty-plus]');
    if (plusButton) {
      event.preventDefault();
      changeQuantity(plusButton, 1);
    }
  });

  document.addEventListener('submit', function (event) {
    var productForm = event.target.closest && event.target.closest('.ddp-product-form');
    if (!productForm) return;

    submitProductForm(event, productForm);
  });

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-ddp-variant-radio]')) {
      updateProductVariant(event.target);
    }

    if (event.target.matches('[data-ddp-filter-input]')) {
      var filterForm = event.target.closest('#DdpCollectionFilters');
      if (filterForm) {
        filterForm.submit();
      }
    }
  });

  document.addEventListener('toggle', function (event) {
    var currentNavMenu = event.target.closest && event.target.closest('[data-ddp-nav-menu]');
    if (currentNavMenu) {
      if (currentNavMenu.open) {
        document.querySelectorAll('[data-ddp-nav-menu][open]').forEach(function (menu) {
          if (menu !== currentNavMenu) {
            menu.removeAttribute('open');
          }
        });

        var searchInput = currentNavMenu.querySelector('[data-ddp-search-input]');
        if (searchInput) {
          window.setTimeout(function () {
            searchInput.focus();
          }, 0);
        }
      }

      syncNavMenuState();
      return;
    }

    var currentMenu = event.target.closest && event.target.closest('[data-ddp-filter-menu]');
    if (!currentMenu) return;

    if (currentMenu.open) {
      document.querySelectorAll('[data-ddp-filter-menu][open]').forEach(function (menu) {
        if (menu !== currentMenu) {
          menu.removeAttribute('open');
        }
      });

      resetFilterMenuScroll(currentMenu);
    }

    syncFilterState();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeCollectionFilterPanel(true);
      closeAllFilterMenus(true);
      closeAllNavMenus(true);
      document.querySelectorAll('[data-ddp-product-section]').forEach(function (section) {
        closeCompactOptionPanels(section, true);
      });
    }
  });

  syncFilterState();
  syncNavMenuState();
  initProductOptions();
  initProductGalleries();
})();
